import type { UnderwritableEntitiesV4 } from "@tycho/web-bindings/types";
import { useSuspendedSmbSuperViewRows } from "@/web/routes/_protected/smb/-dashboard/dashboardData";

export function useSuspendedSmbSuperView(underwritableEntityId: UnderwritableEntitiesV4["id"]) {
  // Reads the live `smb_super_view` subscription for the signed-in user, or the
  // injected admin snapshot inside the `/admin/smb/$brandId` viewer — see
  // `dashboardData.tsx`.
  const smbSuperView = useSuspendedSmbSuperViewRows();
  const superViewForEntity = smbSuperView.find(
    (info) => info.underwritableEntityId.toString() === underwritableEntityId.toString(),
  );
  if (!superViewForEntity) {
    throw new Error("SMB super view not found for entity");
  }
  return superViewForEntity;
}
